import { ChangeDetectionStrategy, Component, input, model, signal } from '@angular/core';
import type { FormValueControl } from '@angular/forms/signals';
import { UiFieldControl } from '../../../basics/ui-field-control';
import { InputFieldComponent } from '../../atoms/input-field/input-field.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IconUIComponent } from '../../atoms/icon/icon.component';
import { UiFieldActionDirective } from '../../../directives';
import { InputAutocompleteType, InputSizeType, InputType } from '../../../types';

@Component({
  selector: 'fr8bot-ui-password-field',
  imports: [InputFieldComponent, IconUIComponent, UiFieldActionDirective, TranslatePipe],
  templateUrl: './password-field.component.html',
  styleUrl: './password-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFieldComponent
  extends UiFieldControl
  implements FormValueControl<string | null>
{
  readonly value = model<string | null>(null);

  readonly label = input<string | null>(null);
  readonly placeholder = input('');
  readonly size = input<InputSizeType>('large');
  readonly isFocused = input(false);
  readonly inputName = input<string | null>(null);
  readonly autocomplete = input<InputAutocompleteType | null>(null);

  protected readonly inputType = signal<InputType>(InputType.Password);

  protected toggleType(): void {
    this.inputType.update((type) =>
      type === InputType.Password ? InputType.Text : InputType.Password,
    );
  }
}
